module.exports = __webpack_public_path__ + "assets/img/driver-btn-495eaea7.png";